<template>
  <div class="container SupplierDataEdit">
    <el-tabs v-model="currentTab">
      <el-tab-pane :label="$t('settlementUnit.SupplierDataInfo')" name="1">
        <div class="searchBox_top">
          <el-button class="btn" size="mini" type="primary" v-show="auditStatus == 'draft' || auditStatus == 'appr_rej' || (auditStatus == 'appr_pass' && emplFlag == 'MDM')" v-acl="SubmitUnitOfAccount" @click="saveDetail">{{ $t('common.saveDraft') }}</el-button>
          <el-button class="btn" size="mini" type="primary" v-show="(auditStatus == 'draft' || auditStatus == 'appr_rej' || (auditStatus == 'appr_pass' && emplFlag == 'MDM')) && id != null" v-acl="SubmitUnitOfAccount" @click="submitDetail">{{ $t('common.submit') }}</el-button>
          <el-button class="btn" size="mini" type="primary" v-show="canAudit && auditStatus != 'appr_rej'" @click="approvalFun">{{ $t('supplierManage.audit') }}</el-button>
          <!-- 下发MDM -->
          <el-button class="btn" size="mini" type="primary" v-show="auditStatus == 'appr_pass' && emplFlag == 'MDM'" @click="sendToMDM" v-acl="SendUnitOfAccountToMDM">{{ $t('settlementUnit.sendToMDM') }}</el-button>
          <el-button class="btn" size="mini" type="primary" v-acl="RecallUnitOfAccount" v-show="(auditStatus == 'appr_in' || auditStatus == 'appr_rej') && unitOfAccountForm.hasHistory" @click="withdrawFun">{{ $t('common.withdraw') }}</el-button>
          <el-button class="btn" size="mini" type="primary" @click="historyBack">{{ $t('common.close') }}</el-button>
        </div>
        <el-card class="box-card">
          <!--供应商主数据维护-->
          <div slot="header" class="clearfix">
            <span>{{ $t('settlementUnit.dataInfo') }}</span>
          </div>
          <el-form :model="unitOfAccountForm" ref="unitOfAccountForm" :rules="unitOfAccountRules" label-width="160px">
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('settlementUnit.suppliercodeOrInvitationCode')" prop="groupSupplierCode" v-if="emplFlag == 'SUP'">
                  <!--供应商邀请码-->
                  <el-input v-model.trim="unitOfAccountForm.groupSupplierCode" clearable maxlength="20" disabled>
                  </el-input>
                </el-form-item>
                <el-form-item :label="$t('settlementUnit.suppliercodeOrInvitationCode')" prop="groupSupplierCode" v-else>
                  <!--供应商邀请码-->
                  <el-input v-model.trim="unitOfAccountForm.groupSupplierCode" clearable @input="blurGroupSupplierCode" @clear="clearGroupSupplierCode" maxlength="20" :disabled="!(auditStatus == 'draft' || auditStatus == 'appr_rej' || (auditStatus == 'appr_pass' && emplFlag == 'MDM'))">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('supplierManage.supplierType')" prop="groupType">
                  <!--供应商类型-->
                  <ic-select table="TM_SUPPLIER" field="GROUP_TYPE" v-model="unitOfAccountForm.groupType" clearable disabled></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('supplierManage.supplierAbbreviation')" prop="nameShort">
                  <!--供应商简称-->
                  <el-input v-model.trim="unitOfAccountForm.nameShort" clearable disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('settlementUnit.supplierNameCn')" prop="nameCn">
                  <!--供应商中文名称-->
                  <el-input v-model="unitOfAccountForm.nameCn" maxlength="20" clearable :disabled="!(auditStatus == 'draft' || auditStatus == 'appr_rej' || (auditStatus == 'appr_pass' && emplFlag == 'MDM'))"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('settlementUnit.suppliernameEn')" prop="nameEn">
                  <!--供应商英文名称-->
                  <el-input v-model="unitOfAccountForm.nameEn" maxlength="100" clearable :disabled="!(auditStatus == 'draft' || auditStatus == 'appr_rej' || (auditStatus == 'appr_pass' && emplFlag == 'MDM'))"></el-input>
                </el-form-item>
              </el-col>
              <!-- 结算单位编码 -->
              <el-col :span="8">
                <el-form-item :label="$t('settlementUnit.queryConditionSupplierCode')" prop="code" :rules="(!$route.query.id || canAudit || ((auditStatus == 'draft' || auditStatus == 'appr_rej') && unitOfAccountForm.createType == 'MDM')) && emplFlag == 'MDM' && unitOfAccountForm.groupType == 'CARRIER' ? unitOfAccountRules.code : [{ required: false }]">
                  <el-input v-model.trim="unitOfAccountForm.code" clearable :disabled="(!$route.query.id || canAudit || ((auditStatus == 'draft' || auditStatus == 'appr_rej') && unitOfAccountForm.createType == 'MDM')) && emplFlag == 'MDM' && unitOfAccountForm.groupType == 'CARRIER' ? false : true"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="GLN" prop="gln">
                  <el-input v-model="unitOfAccountForm.gln" maxlength="13" clearable :disabled="!(auditStatus == 'draft' || auditStatus == 'appr_rej' || (auditStatus == 'appr_pass' && emplFlag == 'MDM'))"></el-input>
                </el-form-item>
              </el-col>
              <!--审核状态-->
              <el-col :span="8">
                <el-form-item :label="$t('supplierManage.auditStatus')" prop="auditStatus">
                  <ic-select clearable table="TM_UNIT_OF_ACCOUNT" field="STATUS" v-model="unitOfAccountForm.auditStatus" disabled></ic-select>
                </el-form-item>
              </el-col>
              <!-- 社会统一信息代码 -->
              <el-col :span="8">
                <el-form-item :label="$t('supplierManage.socialUniformCreditCode')" prop="socialUniformCreditCode">
                  <el-input v-model="unitOfAccountForm.socialUniformCreditCode" clearable :disabled="!(auditStatus == 'draft' || auditStatus == 'appr_rej' || (auditStatus == 'appr_pass' && emplFlag == 'MDM'))"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if='emplFlag == "MDM"'>
                <el-form-item :label="$t('settlementUnit.department')" prop="department">
                  <!--部门 MDM可看-->
                  <ic-select clearable table="TM_SUPPLIER" field="DEPARTMENT" v-model="unitOfAccountForm.department" disabled></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if='emplFlag == "MDM"'>
                <el-form-item :label="$t('common.status')" prop="status">
                  <!--启用禁用 MDM可看-->
                  <el-select v-model="unitOfAccountForm.status" :placeholder="$t('common.sel')" :disabled="!(auditStatus == 'draft' || auditStatus == 'appr_rej' || (auditStatus == 'appr_pass' && emplFlag == 'MDM'))">
                    <el-option :label="$t('base.common.statusAble')" value="1"></el-option>
                    <el-option :label="$t('base.common.statusDisable')" value="0"></el-option>
                    <el-option label="已淘汰" value="2"></el-option>

                  </el-select>
                  <!-- <ic-select clearable table="COMMON" field="DISABLE_ENABLE_CODE" v-model="unitOfAccountForm.status"></ic-select> -->
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!--选择审批人-->
                <el-form-item :label="$t('settlementUnit.SubmitBy')" prop="ssCategoryLeaderId">
                  <el-select v-model="unitOfAccountForm.ssCategoryLeaderId" clearable>
                    <el-option :key="index" v-for="( item, index ) in  SubmitBySSList " :label="item.userName" :value="item.tmUserId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
        <el-card class="box-card">
          <!--供应商联系人-->
          <div slot="header" class="clearfix">
            <span>{{ $t('settlementUnit.contacts') }}</span>
          </div>
          <div class="toolsBox" v-if="auditStatus == 'draft' || auditStatus == 'appr_rej' || (auditStatus == 'appr_pass' && emplFlag == 'MDM')">
            <el-button type="primary" v-acl="SubmitUnitOfAccount" @click="addUser()" v-if="formlinkUsers.linkUsersList.length < 5 && isShow">{{
              $t('common.addNew') }}</el-button>
            <el-button type="danger" v-acl="SubmitUnitOfAccount" @click="delUser()" v-if="isShow">{{ $t('common.del') }}</el-button>
          </div>
          <el-form :model="formlinkUsers" ref="formlinkUsers" :rules="ruleslinkUsers">
            <el-table :data="formlinkUsers.linkUsersList" ref="linkUsersList" border highlight-current-row max-height='420'>
              <el-table-column prop="trLinkUserId" type="selection" min-width="55" />
              <el-table-column show-overflow-tooltip prop="name" :label="$t('settlementUnit.contacts')" min-width="120">
                <template slot-scope="scope">
                  <el-form-item :prop="'linkUsersList.' + scope.$index + '.name'" :rules="ruleslinkUsers.name">
                    <el-input v-model="scope.row.name">&nbsp;</el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="tel" :label="$t('settlementUnit.tel')" min-width="120">
                <template slot-scope="scope">
                  <!-- <el-form-item :prop=" 'linkUsersList.' + scope.$index + '.tel' "> -->
                  <el-form-item :prop="'linkUsersList.' + scope.$index + '.tel'" :rules="ruleslinkUsers.tel">
                    <el-input v-model="scope.row.tel" maxlength="60">&nbsp;</el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="officeTel" label="办公室电话" min-width="120">
                <template slot-scope="scope">
                  <!-- <el-form-item :prop=" 'linkUsersList.' + scope.$index + '.tel' "> -->
                  <el-form-item :prop="'linkUsersList.' + scope.$index + '.officeTel'" :rules="ruleslinkUsers.tel">
                    <el-input v-model="scope.row.officeTel" maxlength="60">&nbsp;</el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="email" :label="$t('sys.userList.email')" min-width="120">
                <template slot-scope="scope">
                  <el-form-item :prop="'linkUsersList.' + scope.$index + '.email'" :rules="ruleslinkUsers.email">
                    <el-input v-model="scope.row.email" maxlength="50">&nbsp;</el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="title" :label="$t('supplierManage.position')" min-width="120">
                <template slot-scope="scope">
                  <el-form-item :prop="'linkUsersList.' + scope.$index + '.title'" :rules="ruleslinkUsers.title">
                    <el-input v-model="scope.row.title">&nbsp;</el-input>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </el-card>
        <el-card class="box-card">
          <!--供应商地址信息-->
          <div slot="header" class="clearfix">
            <span>{{ $t('settlementUnit.addressInformation') }}</span>
            <span class="addressInformationTip">{{ $t('settlementUnit.addressInformationTip') }}</span>
          </div>
          <div style="display: flex;">
            <div class="toolsBox" v-show="auditStatus == 'draft' || auditStatus == 'appr_rej' || (auditStatus == 'appr_pass' && emplFlag == 'MDM')">
              <el-button type="primary" @click="addSupplierAddress()" v-acl="SubmitUnitOfAccount" v-if="unitOfAccountForm.groupType != 'CARRIER' && isShow">{{ $t('common.addNew') }}</el-button>
              <el-button type="danger" @click="delSupplierAddress()" v-acl="SubmitUnitOfAccount" v-if="unitOfAccountForm.groupType != 'CARRIER' && isShow">{{ $t('common.del') }}</el-button>
            </div>
            <div class="toolsBox" style="margin-left:12px;" v-if="(auditStatus == 'appr_pass' && emplFlag == 'MDM')">
              <el-button type=" primary" v-acl="SubmitUnitOfAccount" @click="editPlant" v-if="emplFlag == 'MDM'">工厂编码修改</el-button>
            </div>
          </div>

          <el-form :model="formAddress" ref="formAddress" :rules="rulesAddress">
            <el-table :data="formAddress.plantList" ref="plantList" border highlight-current-row max-height='420'>
              <el-table-column prop="tmSupplierId" type="selection" min-width="55" :selectable="(row, index) => index != 0" />
              <el-table-column show-overflow-tooltip prop="nameCn" :label="$t('sys.roleList.roleCN')" min-width="120">
                <!-- 中文名称 -->
                <template slot-scope="scope">
                  <el-form-item :prop="'plantList.' + scope.$index + '.nameCn'" :rules="rulesAddress.nameCn">
                    <el-input v-model="scope.row.nameCn" maxlength="33" :disabled='scope.$index != 0 && unitOfAccountForm.groupType == "SUPPLIER"'>&nbsp;</el-input>
                    <!-- <el-input v-model="scope.row.nameCn" :disabled='scope.$index!=0' maxlength="33">&nbsp;</el-input> -->
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="nameEn" :label="$t('sys.roleList.roleEN')" min-width="120">
                <!-- 英文名称 -->
                <template slot-scope="scope">
                  <el-form-item :prop="'plantList.' + scope.$index + '.nameEn'" :rules="rulesAddress.nameEn">
                    <el-input v-model="scope.row.nameEn" maxlength="100" :disabled='scope.$index != 0 && unitOfAccountForm.groupType == "SUPPLIER"'>&nbsp;</el-input>
                    <!-- <el-input v-model="scope.row.nameEn" :disabled='scope.$index!=0' maxlength="100">&nbsp;</el-input> -->
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop='plantType' :label="$t('settlementUnit.addressType')" min-width="120">
                <!-- 地址类型 -->
                <template slot-scope="scope">
                  <el-form-item :prop="'plantList.' + scope.$index + '.plantType'" :rules="rulesAddress.plantType">
                    <el-select v-model="scope.row.plantType" disabled>
                      <el-option key="REG" :label="$t('settlementUnit.cra')" value="REG"></el-option>
                      <el-option key="PLANT" :label="$t('settlementUnit.factoryAddress')" value="PLANT"></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop='plantCode' :label="$t('settlementUnit.code')" min-width="50" v-if="emplFlag == 'MDM'">
                <!-- 编码 -->
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="areaId" :label="$t('supplierManage.area')" min-width="160">
                <template slot-scope="scope">
                  <el-link type="primary" @click="selectArea(scope.row, scope.$index)" v-if="scope.row.areaId">{{
                    scope.row.countryName }}{{ scope.row.provinceName }}{{ scope.row.cityName }}{{ scope.row.areaName
  }}</el-link>
                  <el-link type="primary" @click="selectArea(scope.row, scope.$index)" v-else>{{ $t('supplierManage.area')
                  }}</el-link>
                  <!--区域-->
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="address" :label="$t('settlementUnit.detailAddress')" min-width="140">
                <!-- 详细地址 -->
                <template slot-scope="scope">
                  <el-form-item :prop="'plantList.' + scope.$index + '.address'" :rules="rulesAddress.address">
                    <el-input v-model="scope.row.address" :disabled='scope.$index != 0 && unitOfAccountForm.groupType == "SUPPLIER"'>&nbsp;</el-input>
                    <!-- <el-input v-model="scope.row.address" :disabled='scope.$index!=0'>&nbsp;</el-input> -->
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="linkman" :label="$t('settlementUnit.contacts')" min-width="120">
                <!-- 联系人 -->
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" placement="top" v-if="scope.row.users && scope.row.users.length > 0">
                    <div slot="content">
                      <span v-for="( item, index ) in  scope.row.users " :key="index">{{ $t('settlementUnit.contacts')
                      }}：{{
  item.name }}，{{ $t('settlementUnit.telephone') }}：{{ item.tel }}，{{ $t('settlementUnit.email')
  }}：{{ item.email }}<br /></span>
                    </div>
                    <el-link type="primary" @click="addAddressUser(scope.row, scope.$index)">{{ scope.row.users[0].name
                    }}</el-link>
                  </el-tooltip>
                  <el-link type="primary" @click="addAddressUser(scope.row, scope.$index)" v-else>{{
                    $t('settlementUnit.addTo') }}</el-link>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="tel" :label="$t('settlementUnit.tel')" min-width="100">
                <!-- 联系电话 -->
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" placement="top" v-if="scope.row.users && scope.row.users.length > 0">
                    <div slot="content">
                      <span v-for="( item, index ) in  scope.row.users " :key="index">{{ $t('settlementUnit.contacts')
                      }}：{{
  item.name }}，{{ $t('settlementUnit.telephone') }}：{{ item.tel }}，{{ $t('settlementUnit.email')
  }}：{{ item.email }}<br /></span>
                    </div>
                    <el-link type="primary" @click="addAddressUser(scope.row, scope.$index)">{{ scope.row.users[0].tel
                    }}</el-link>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="officeTel" label="办公室电话" min-width="100">
                <!-- 联系电话 -->
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" placement="top" v-if="scope.row.users && scope.row.users.length > 0">
                    <div slot="content">
                      <span v-for="( item, index ) in  scope.row.users " :key="index">{{ $t('settlementUnit.contacts')
                      }}：{{
  item.name }}，{{ $t('settlementUnit.telephone') }}：{{ item.tel }}，{{ $t('settlementUnit.email')
  }}：{{ item.email }}，办公室电话 ：{{ item.officeTel }}<br /></span>
                    </div>
                    <el-link type="primary" @click="addAddressUser(scope.row, scope.$index)">{{
                      scope.row.users[0].officeTel }}</el-link>
                  </el-tooltip>
                </template>
              </el-table-column>

              <el-table-column show-overflow-tooltip prop="email" :label="$t('sys.userList.email')" min-width="120">
                <!-- 邮箱 -->
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" placement="top" v-if="scope.row.users && scope.row.users.length > 0">
                    <div slot="content">
                      <span v-for="( item, index ) in  scope.row.users " :key="index">{{ $t('settlementUnit.contacts')
                      }}：{{
  item.name }}，{{ $t('settlementUnit.telephone') }}：{{ item.tel }}，{{ $t('settlementUnit.email')
  }}：{{ item.email }}<br /></span>
                    </div>
                    <el-link type="primary" @click="addAddressUser(scope.row, scope.$index)">{{ scope.row.users[0].email
                    }}</el-link>
                  </el-tooltip>

                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="postCode" :label="$t('settlementUnit.Postcode')" min-width="120">
                <!-- 邮编 -->
                <template slot-scope="scope">
                  <el-form-item :prop="'plantList.' + scope.$index + '.postCode'" :rules="rulesAddress.postCode">
                    <el-input v-model="scope.row.postCode" maxLength='6' onkeyup="this.value=this.value.replace(/\D/g,'')" :disabled='scope.$index != 0 && unitOfAccountForm.groupType == "SUPPLIER"'>&nbsp;</el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip :label="$t('settlementUnit.qualificationFile')" min-width="80">
                <!-- 资质文件 -->
                <template slot-scope="scope">
                  <i class="el-icon-folder-checked iconUploadSuccess" v-if="scope.row.existsFile == 'Y'"></i>
                  <el-link type="primary" @click="seeQualificationFile(scope.row, scope.$index)">{{ $t('common.upload') }}</el-link>
                  <!--上传-->
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop='status' :label="$t('settlementUnit.status')" min-width="120">
                <!-- 启用禁用 -->
                <template slot-scope="scope">
                  <el-form-item :prop="'plantList.' + scope.$index + '.status'" :rules="rulesAddress.status" v-if="scope.$index != 0">
                    <!-- MDM 审批通过 的时候 要可以改 -->
                    <el-select v-model="scope.row.status" :disabled='!(unitOfAccountForm.groupType == "SUPPLIER" && auditStatus == "appr_pass" && emplFlag == "MDM") || emplFlag == "SUP"'>
                      <el-option key="0" :label="$t('settlementUnit.disabled')" value="0"></el-option>
                      <el-option key="1" :label="$t('settlementUnit.enabled')" value="1"></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </el-card>
      </el-tab-pane>
      <el-tab-pane :label="$t('settlementUnit.qualificationFile')" name="2" v-if="id">
        <!--资质文件-->
        <el-table :data="LegalFileList" border highlight-current-row max-height='500'>
          <el-table-column show-overflow-tooltip :label="$t('settlementUnit.qualificationDocuments')" prop='title'></el-table-column>
          <el-table-column show-overflow-tooltip :label="$t('settlementUnit.template')" prop='templateName'>
            <!--范本-->
            <template slot-scope="scope">
              <el-link type="primary" @click.native="downloadTemplate(scope.row.template, scope.row.templateName)">{{
                scope.row.templateName }}
              </el-link>
              <el-link type="primary" @click.native="downloadTemplate(scope.row.template2, scope.row.templateName2)">{{
                scope.row.templateName2 }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label="$t('settlementUnit.historicalFileVersion')" prop='historyFile'>
            <!--历史文件版本-->
            <template scope="scope">
              <el-link style="display:block" type="primary" v-for='( v, index ) in  scope.row.historyFile ' :key="index" @click.native="downloadhistoryFile(v)">{{ v.documentName }} </el-link>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label="$t('settlementUnit.currentVersionFile')" prop='currentName'>
            <template slot-scope="scope">
              <el-link type="primary" @click.native="downloadLegalFile(scope.row)">{{ scope.row.currentName }} </el-link>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :label="$t('settlementUnit.status')" prop='status' :formatter="formatStatus" width="160" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip :label="$t('settlementUnit.operation')" width="200">
            <!-- <el-table-column v-if="unitOfAccountForm.auditStatus!='appr_in' && unitOfAccountForm.auditStatus!='appr_pass'" label="操作" width="200"> -->
            <template slot-scope="scope">
              <div class="operationBox">
                <div v-if="scope.$index == 0 || scope.$index == 1 || scope.$index == 2 || scope.$index == 4" style="margin-left:10px">
                  <el-button type="primary" size='mini' v-acl="SubmitUnitOfAccount" @click="toLegalFileDetail(scope.row.formType)">{{
                    $t('settlementUnit.createApplication') }}</el-button>
                  <!--创建申请-->
                </div>
                <div v-if="scope.$index == 3" style="margin-left:10px">
                  <el-button type="primary" size='mini' v-acl="SubmitUnitOfAccount" @click="toEngagementDetail">{{ $t('common.see') }}</el-button>
                  <!--查看-->
                </div>
                <div v-else>
                  <!--归档=上传-->
                  <div v-acl="SubmitUnitOfAccount" @click="getLegalFileIndex(scope.$index, scope.row)" v-if="scope.$index != 15">
                    <el-upload style="margin-left:10px" ref="upload" action="upload" :http-request="uploadLegalFile" :show-file-list="false" multiple size='mini' name="file">
                      <el-button slot="trigger" size="small" type="primary">{{ $t('common.upload') }}</el-button>
                    </el-upload>
                  </div>
                  <div v-acl="SubmitUnitOfAccount" @click="getLegalFileIndex(scope.$index, scope.row)" v-if="scope.$index == 15 && emplFlag != 'SUP'">
                    <el-upload style="margin-left:20px" ref="upload" action="upload" :http-request="uploadLegalFile" :show-file-list="false" multiple size='mini' name="file">
                      <el-button slot="trigger" size="small" type="primary">{{ $t('settlementUnit.placeFile')
                      }}</el-button>
                    </el-upload>
                  </div>
                </div>
              </div>
            </template>

          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane :label="$t('common.approvalLog')" name="3" v-if="id">
        <!--审批日志-->
        <el-table :data="auditLog" border highlight-current-row class="table">
          <el-table-column show-overflow-tooltip prop="createDate" :label="$t('common.OperationTime')">
            <template slot-scope="scope">{{ scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm:ss") }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="operatorName" :label="$t('common.OperatorName')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="action" :label="$t('common.PedagogicalOperation')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="comments" :label="$t('common.opinion')"></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :visible.sync="showSelDcMultipleDialog" append-to-body width="85%" @close='closeSelDcMultipleDialog'>
      <SelDc v-if="DestroyIncomeStatistics == true" ref="selectDcMultipleRef" :multipleSelectionFlag="true" :id=tmSupplierId @subCallMethod="selectDcMethod"></SelDc>
    </el-dialog>
    <el-dialog :visible.sync="AreaDialog" width="400px">
      <!--区域弹框-->
      <el-form :model="AreaForm" ref="AreaForm" label-width="60px">
        <el-row type="flex" justify="space-around">
          <el-col :span="20">
            <el-form-item :label="$t('settlementUnit.country')" prop="country">
              <el-select v-model="AreaForm.country" :placeholder="$t('common.sel')" @change="countryChange">
                <!-- <el-select v-model="AreaForm.country" :placeholder="$t('common.sel')" @change="countryChange" :disabled="disableAreaInput"> -->
                <el-option clearable v-for=" item  in  countryList " :key="item.tmAreaId" :label="item.name" :value="item.tmAreaId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-around">
          <el-col :span="20">
            <el-form-item :label="$t('settlementUnit.province')" prop="province">
              <el-select v-model="AreaForm.province" :placeholder="$t('common.sel')" @change="provinceChange">
                <el-option clearable v-for=" item  in  provinceList " :key="item.tmAreaId" :label="item.name" :value="item.tmAreaId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-around">
          <el-col :span="20">
            <el-form-item :label="$t('settlementUnit.city')" prop="city">
              <el-select v-model="AreaForm.city" :placeholder="$t('common.sel')" @change="cityChange">
                <el-option clearable v-for=" item  in  cityList " :key="item.tmAreaId" :label="item.name" :value="item.tmAreaId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-around">
          <el-col :span="20">
            <el-form-item :label="$t('settlementUnit.tmAreaId')" prop="tmAreaId">
              <el-select v-model="AreaForm.tmAreaId" :placeholder="$t('common.sel')" @change="AreaChange">
                <el-option clearable v-for=" item  in  AreaList " :key="item.tmAreaId" :label="item.name" :value="item.tmAreaId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <!-- <el-button type="primary" @click="saveArea" v-if="!disableAreaInput">{{$t('common.save')}}</el-button> -->
        <el-button type="primary" v-acl="SubmitUnitOfAccount" @click="saveArea">{{ $t('common.save') }}</el-button>
        <el-button type="primary" @click="AreaDialog = false">{{ $t('common.close') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="qualificationsDialog" width="50%" :before-close='closeQualificationsDialog'>
      <!--资质文件弹框-->
      <el-table :data="qualificationsList" border highlight-current-row class="table">
        <el-table-column prop="HeaderName" :label="$t('common.file')" max-width="130px"></el-table-column>
        <el-table-column prop="documentName" :label="$t('supplierManage.fileName')">
          <!--文件-->
          <template slot-scope="scope">
            <el-link type="primary" v-if="scope.row.tmDocumentId" @click.native="downloadQualifications(scope.row)">{{
              scope.row.documentName }} </el-link>
            <span v-else>{{ scope.row.documentName }}</span>
          </template>
        </el-table-column>
        <el-table-column width="160px" :label="$t('common.operation')" v-if="!disableAddressUserInput">
          <template slot-scope="scope">
            <div class="searchBox_bottom">
              <div v-acl="SubmitUnitOfAccount" @click="getFileIndex(scope.$index)">
                <el-upload ref="upload" action="upload" :http-request="uploadQualifications" :show-file-list="false" multiple name="file">
                  <el-button slot="trigger" size="mini" type="primary">{{ $t('common.selectFile') }}</el-button>
                </el-upload>
              </div>
              <!-- <el-button type="danger" size="mini" @click="delQualificationsr(scope.$index,scope.row)">{{$t('common.del')}}</el-button> -->
            </div>

          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="closeQualificationsDialog">{{ $t('common.close') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="$t('supplierManage.approvalWindow')" :visible.sync="approvalVisible" width="25%">
      <el-form :model="approvaForm" ref="approvaForm" :rules="approvaRules" inline label-width="90px">
        <el-form-item :label="$t('storeFeedback.auditor')" prop="auditor">
          <el-input v-model="approvaForm.auditor" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.approvalTime')" prop="approvalTime">
          <el-input v-model="approvaForm.approvalTime" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.RevisionComments')" prop="approvalResults">
          <el-radio-group v-model="approvaForm.approvalResults">
            <el-radio label="PASS">{{ $t('common.pass') }}</el-radio>
            <el-radio label="REJECT">{{ $t('common.noPass') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('settlementUnit.approvalRemarks')" prop="approvalRemarks" :rules="approvaForm.approvalResults == 'REJECT' ? approvaForm.approvalRemarks : []">
          <el-input v-model="approvaForm.approvalRemarks" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" maxlength="300" style="width:200px"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="approvalVisible = false" type="primary">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" v-acl="SubmitUnitOfAccount" @click="approvalConfirm()">{{ $t('common.confirm') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="addressAddSupplierContactListDialog" width="80%" :before-close="closeSupplierContactsAddress">
      <!--地址 添加联系人弹窗-->
      <template v-if="!disableAddressUserInput">
        <el-button type="primary" v-acl="SubmitUnitOfAccount" @click="addSupplierContactsAddress()" v-if="addressAddSupplierContactListForm.addresslinkUsersList.length < 5">{{ $t('common.addNew') }}</el-button>
        <el-button type="danger" v-acl="SubmitUnitOfAccount" @click="delSupplierContactsAddress()">{{ $t('common.del') }}</el-button>
      </template>
      <el-form :model="addressAddSupplierContactListForm" ref="addressAddSupplierContactListForm" :rules="rulesAddressAddSupplierContactList">
        <el-table :data="addressAddSupplierContactListForm.addresslinkUsersList" ref="addresslinkUsersList" border highlight-current-row max-height='420'>
          <el-table-column prop="trLinkUserId" type="selection" min-width="55" :selectable="(row) => !row.titleDisabled" />
          <el-table-column show-overflow-tooltip prop="name" :label="$t('settlementUnit.contacts')" min-width="120">
            <!-- 联系人 -->
            <template slot-scope="scope">
              <el-form-item :prop="'addresslinkUsersList.' + scope.$index + '.name'" :rules="rulesAddressAddSupplierContactList.name">
                <!-- <el-form-item :prop=" 'addresslinkUsersList.' + scope.$index + '.name' " :rules="scope.$index==0?rulesAddressAddSupplierContactList.name:[]"> -->
                <el-input v-model="scope.row.name" :disabled='disableAddressUserInput'></el-input>
                <!-- <el-input v-model="scope.row.name">&nbsp;</el-input> -->
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="tel" :label="$t('settlementUnit.tel')" min-width="120">
            <!-- 联系电话 -->
            <template slot-scope="scope">
              <el-form-item :prop="'addresslinkUsersList.' + scope.$index + '.tel'" :rules="rulesAddressAddSupplierContactList.tel">
                <!-- <el-form-item :prop=" 'addresslinkUsersList.' + scope.$index + '.tel' " :rules="scope.$index==0?rulesAddressAddSupplierContactList.tel:[]"> -->
                <el-input v-model="scope.row.tel" maxlength="60" :disabled='disableAddressUserInput'>&nbsp;</el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="officeTel" label="办公室电话" min-width="120">
            <!-- 联系电话 -->
            <template slot-scope="scope">
              <el-form-item :prop="'addresslinkUsersList.' + scope.$index + '.officeTel'" :rules="rulesAddressAddSupplierContactList.officeTel">
                <!-- <el-form-item :prop=" 'addresslinkUsersList.' + scope.$index + '.tel' " :rules="scope.$index==0?rulesAddressAddSupplierContactList.tel:[]"> -->
                <el-input v-model="scope.row.officeTel" maxlength="60" :disabled='disableAddressUserInput'>&nbsp;</el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="email" :label="$t('settlementUnit.email')" min-width="120">
            <template slot-scope="scope">
              <el-form-item :prop="'addresslinkUsersList.' + scope.$index + '.email'" :rules="rulesAddressAddSupplierContactList.email">
                <!-- <el-form-item :prop=" 'addresslinkUsersList.' + scope.$index + '.email' " :rules="scope.$index==0?rulesAddressAddSupplierContactList.email:[]"> -->
                <el-input v-model="scope.row.email" maxlength="50" :disabled='disableAddressUserInput'>&nbsp;</el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="title" label="Title" min-width="120">
            <template slot-scope="scope">
              <el-form-item :prop="'addresslinkUsersList.' + scope.$index + '.title'" :rules="rulesAddressAddSupplierContactList.title">
                <!-- <el-form-item :prop=" 'addresslinkUsersList.' + scope.$index + '.title' " :rules="scope.$index==0?rulesAddressAddSupplierContactList.title:[]"> -->
                <!-- <el-input v-model="scope.row.title">&nbsp;</el-input> -->
                <ic-select table="TM_UNIT_OF_ACCOUNT" field="REG_CONTACT_TYPE" v-model="scope.row.title" v-if='rowIndex == 0' :disabled='scope.row.titleDisabled || disableAddressUserInput'></ic-select>
                <ic-select table="TM_UNIT_OF_ACCOUNT" field="PLANT_CONTACT_TYPE" v-model="scope.row.title" v-else :disabled='scope.row.titleDisabled || disableAddressUserInput'></ic-select>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <!-- <el-button type="primary" @click="saveSupplierContactsAddress">{{$t('common.save')}}</el-button> -->
        <el-button type="primary" v-acl="SubmitUnitOfAccount" @click="saveSupplierContactsAddress" v-if="!disableAddressUserInput">{{
          $t('common.save') }}</el-button>
        <el-button type="primary" @click="closeSupplierContactsAddress()">{{ $t('common.close') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog class="group_dialog" :visible.sync="dialogVisible2" title="工厂编码修改" width="30%" :close-on-click-modal="false">
      <el-form :model="plantCodeForm" class="plantCodeForm" ref="plantCodeForm" label-width="130px" label-position="right" :rules="rulesPlantCode">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="工厂编码" prop="plantCode" class="mandatory">
              <el-input v-model="plantCodeForm.plantCode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center" style="margin-bottom:10px">
          <el-button size="mini" v-acl="SubmitUnitOfAccount" @click="savePlantCode" type="primary">保存</el-button>
          <el-button size="mini" @click="cancelPlantCode" type="primary">取消</el-button>
        </el-row>
      </el-form>
    </el-dialog>

  </div>
</template>
<script>
import BCApi from "@/api/BC/BC";
import IcSelect from "@/components/common/icSelect";
import { search } from "@/api/base-data/supplier";
import { fileService } from "@/api/common/file-utils";
import commonFun from "@/utils/commonFun";
import unitApi from "@/api/unit/unit";
import supplierApi from "@/api/supplier/supplier";
import SelDc from "@/components/page/settlementUnit/unitAddress";
export default {
  components: { IcSelect, SelDc },
  data() {
    var checkTel = (rule, value, callback) => {
      if (commonFun.isEmpty(value)) {
        return callback(new Error(this.$t("visitPlan.noEmpty")));
      }
      let reg01 = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/;
      let reg02 = /^(0[0-9]{2,3}\-)([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/;
      if (reg01.test(value) || reg02.test(value)) {
        callback();
      } else {
        callback(new Error('格式不正确'));
      }
    };
    var checkEmail = (rule, value, callback) => {
      if (commonFun.isEmpty(value)) {
        return callback(new Error(this.$t("visitPlan.noEmpty")));
      }
      let reg = /^[A-Za-z0-9\u4e00-\u9fa5_\-\.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (!reg.test(value)) {
        callback(new Error(this.$t("sys.userList.inputEmail")));
      } else {
        callback();
      }
    };
    return {
      plantCodeForm: {
        plantCode: "",
      },
      dialogVisible2: false,
      countryName: '',
      provinceName: '',
      cityName: '',
      areaName: '',
      disableAreaInput: '',
      disableAddressUserInput: '',
      addressAddSupplierContactListDialog: false,
      addressAddSupplierContactListForm: {
        addresslinkUsersList: []
      },
      rulesPlantCode: {
        plantCode: [
          { required: true, message: '请输入工厂编码', trigger: ["blur"] }
        ]
      },
      rulesAddressAddSupplierContactList: {
        name: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        tel: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        officeTel: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        email: [
          { required: true, trigger: ["blur"], validator: checkEmail }
        ],
        title: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["change"] }
        ],
      },
      currentTab: '1',
      supplierObj: {},
      auditStatus: 'draft',
      unitOfAccountForm: {
        groupType: '',
        tmSupplierId: '',
        tmUnitOfAccountId: '',
        groupSupplierCode: '',
        nameShort: '',
        nameCn: '',
        nameEn: '',
        gln: '',
        department: '',
        bankName: '',
        bankAddress: '',
        accountNo: '',
        shareholdingRatio: '',
        isPayByCredit: '',
        status: '',
        createType: '',
        ssCategoryLeaderId: '',
        ssCategoryLeaderName: '',
      },
      loginSupplierId: '',
      groupName: '',
      unitOfAccountRules: {
        code: [
          { required: true, message: '请输入结算单位编码', trigger: ["blur"] }
        ],
        groupSupplierCode: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        groupType: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        nameShort: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        nameCn: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        nameEn: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        gln: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        isPayByCredit: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        accountNo: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        bankName: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        bankAddress: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        ssCategoryLeaderId: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["change"] }
        ],
        status: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["change"] }
        ],
        socialUniformCreditCode: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
      },
      formlinkUsers: {
        linkUsersList: [],
      },
      ruleslinkUsers: {
        name: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        tel: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        officeTel: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        email: [
          { required: true, trigger: ["blur"], validator: checkEmail }
        ],
        title: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
      },
      formAddress: {
        plantList: [{ plantType: 'REG', status: '1', existsFile: 'N' }],
      },
      rulesAddress: {
        nameCn: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        nameEn: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        // socialUniformCreditCode: [
        //     { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        // ],
        address: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        linkman: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        telephoneNo: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        emailAddress: [
          { required: true, validator: checkEmail, trigger: ["blur"] }
        ],
        postCode: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
      },
      LegalFileList: [
        { formType: 0, title: '保密协议', historyFile: [], currentPath: '', currentName: '', status: '', template: '/templates/download/附件二 麦当劳保密协议_CN.PDF', templateName: '附件二 麦当劳保密协议_CN.PDF', template2: '/templates/download/附件二 麦当劳保密协议_ENCN.PDF', templateName2: '附件二 麦当劳保密协议_ENCN.PDF', },
        { formType: 1, title: '乐信贸易采购协议-非玩具类', historyFile: [], currentPath: '', currentName: '', status: '', template: '/templates/download/采购协议延伸库存.pdf', templateName: '采购协议延伸库存.pdf' },
        { formType: 2, title: '乐信贸易采购协议-玩具类', historyFile: [], currentPath: '', currentName: '', status: '', template: '/templates/download/采购协议非延伸库存.pdf', templateName: '采购协议非延伸库存.pdf' },
        { title: 'BRA Engagement Form' },
        { formType: 3, title: 'Business Relationship Agreement (业务关系协议）', historyFile: [], currentPath: '', currentName: '', status: '', template: '', templateName: '' },
        { title: '营业执照', historyFile: [], currentPath: '', currentName: '', status: '', template: '', templateName: '' },
        { title: '生产许可证', historyFile: [], currentPath: '', currentName: '', status: '', template: '', templateName: '' },

        { title: '供应商企业基础信息截屏/身份证', historyFile: [], currentPath: '', currentName: '', status: '', template: '', templateName: '' },
        { title: '银行资料\n企业需要盖章确认/个人签字确认', historyFile: [], currentPath: '', currentName: '', status: '', template: '', templateName: '' },
        { title: '供应商行为准则 企业需要盖章确认/个人签字确认', historyFile: [], currentPath: '', currentName: '', status: '', template: '/templates/download/附件五-1 供应商行为准则_CN.pdf', templateName: '附件五-1 供应商行为准则_CN.pdf', template2: '/templates/download/附件五-1 供应商行为准则_EN.pdf', templateName2: '附件五-1 供应商行为准则_EN.pdf', },
        { title: '利益冲突声明 企业需要盖章确认/个人签字确认', historyFile: [], currentPath: '', currentName: '', status: '', template: '/templates/download/附件六 利益冲突声明.docx', templateName: '附件六 利益冲突声明.docx' },

        // {title:'经签署的合同，协议或其他有效资料',historyFile:[],currentPath:'',currentName:'',status:'',template:'',templateName:''},
        { title: '礼品和招待', historyFile: [], currentPath: '', currentName: '', status: '', template: '/templates/download/附件五-2 供应商指导原则-礼品和招待_CN.pdf', templateName: '附件五-2 供应商指导原则-礼品和招待_CN.pdf', template2: '/templates/download/附件五-2 供应商指导原则-礼品和招待_EN.pdf', templateName2: '附件五-2 供应商指导原则-礼品和招待_EN.pdf', },
        // {title:'利益冲突',historyFile:[],currentPath:'',currentName:'',status:'',template:'',templateName:''},
        // {title:'数据电文有效性补充协议',historyFile:[],currentPath:'',currentName:'',status:'',template:'',templateName:''},
        { title: '第三方新增及修改申请表', historyFile: [], currentPath: '', currentName: '', status: '', template: '/templates/download/附件一 第三方新增及修改申请表.xls', templateName: '附件一 第三方新增及修改申请表.xls' },
        { title: '合规评定', historyFile: [], currentPath: '', currentName: '', status: '', template: '', templateName: '' },
        { title: '国家公信网截屏', historyFile: [], currentPath: '', currentName: '', status: '', template: '', templateName: '' },
      ],
      rowIndexLegalFile: '',//法务文件的行index
      rowStatus: '',
      rowIndex: '',
      countryList: [],
      provinceList: [],
      cityList: [],
      AreaList: [],
      AreaDialog: false,
      AreaForm: {
        country: '',
        province: '',
        city: '',
        tmAreaId: '',
      },
      qualificationsDialog: false,
      id: null,
      tmSupplierId: '',
      showSelDcMultipleDialog: false,
      DestroyIncomeStatistics: "",
      qualificationsList: [{ HeaderName: '营业执照(三合一)' }, { HeaderName: '生产许可证' }, { HeaderName: '经营许可证' }],
      QualificationFileId: '',//上传资质文件用到的id
      canAudit: false,
      auditLog: [],//审批日志
      approvaForm: {
        auditor: localStorage.getItem("ms_userCd"),
        approvalTime: this.$options.filters["dateFormatFilter"](new Date()),
        approvalResults: '',
      },
      approvaRules: {
        approvalResults: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }
        ],
        approvalRemarks: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }
        ],
      },
      approvalVisible: false,
      emplFlag: '',
      SubmitBySSList: [],
      isShow: true,

      ms_Permission: [],
      btnVisible: false,
    }
  },
  created() {
    this.ms_Permission = JSON.parse(localStorage.getItem('ms_Permission'));
    if(this.ms_Permission.indexOf("SubmitUnitOfAccount") != -1) {
      this.btnVisible = true;
    } else {
      this.btnVisible = false;
    }
    this.id = this.$route.query.id;
    if (this.$route.query.id) {
      if (this.$route.query.hasHistory) {
        this.hasHistory = this.$route.query.hasHistory
        this.getDetail(this.$route.query.id, this.$route.query.hasHistory)
      } else {
        this.getDetail(this.$route.query.id)
      }
      this.getAccountUnitAddress(this.$route.query.id)
      //获取法务文件 所有（tab页中的）
      this.getLegalFileOther(this.$route.query.id)
      //获取法务文件前四项的status tmLawFileId
      this.getLawFile(this.$route.query.id)
    } else {
    }
    this.getSubmitBySS()
    this.getArea()
    //用户所属系统(SUP供应商)
    const emplFlag = localStorage.getItem("ms_emplFlag");
    //供应商用户
    if (emplFlag === 'SUP') {
      this.emplFlag = 'SUP';
      this.unitOfAccountForm.groupSupplierCode = JSON.parse(localStorage.getItem("supplierObj")).invitationCode
      this.loginSupplierId = JSON.parse(localStorage.getItem("supplierObj")).tmSupplierId
      this.LegalFileList.pop()
      this.LegalFileList.pop()
      this.LegalFileList.pop()
      this.blurGroupSupplierCode()
    } else {
      let permission = JSON.parse(localStorage.getItem("ms_Permission"));
      for (let i = 0, len = permission.length; i < len; i++) {
        if (permission[i] == 'IS_MDM') {
          this.emplFlag = 'MDM';
        }
      }
    }
    this.unitOfAccountForm.createType = this.$route.query.createType;

  },
  mounted() {
    let dataScope = JSON.parse(localStorage.getItem("ms_DataScope"));
    console.log('dataScope', dataScope);
    if (dataScope) {
      if (dataScope.indexOf('SUPPLIER_GROUPING') !== -1 || dataScope.indexOf('MATERIALS_AND_FPA_MAINTAINER') !== -1 || dataScope.indexOf('MATERIALS_MAINTAINER') !== -1) {
        this.isShow = false
      } else {
        this.isShow = true
      }
    }
  },
  methods: {
    getDetail(id, hasHistory = 'N') {
      let that = this
      unitApi.getDetail(id, hasHistory).then(res => {
        this.unitOfAccountForm = res.data
        if (that.unitOfAccountForm.ssCategoryLeaderId) {
          that.unitOfAccountForm.ssCategoryLeaderId = parseInt(that.unitOfAccountForm.ssCategoryLeaderId)
        }
        let linkUsersList = res.data.users
        if (linkUsersList.length > 0) {
          for (let i = 0, len = linkUsersList.length; i < len; i++) {
            linkUsersList[i].delIds = i;
          }
          this.formlinkUsers.linkUsersList = linkUsersList
        }
        // this.formlinkUsers.linkUsersList = res.data.users
        this.canAudit = res.data.canAudit
        this.auditLog = res.data.logs
        this.auditStatus = res.data.auditStatus
        // if (res.data.department == 'NFC') {
        //   this.getSubmitBySS("NFC")
        // } else if (res.data.department == 'SS') {
        //   this.getSubmitBySS("SS")
        // } else if (res.data.department == 'MDM') {
        //   this.getSubmitBySS("MDM")
        // }
      });
    },
    getAccountUnitAddress(id) {
      unitApi.getAccountUnitAddress(id).then(res => {
        this.formAddress.plantList = res.data
      });
    },
    getLawFile(id) {
      let that = this
      unitApi.getLawFile(id).then(res => {
        let data = res.data
        data.forEach((item, index) => {
          if (item.formType == '0') {
            that.LegalFileList[0].status = item.status
            if (item.applyNo) {
              that.LegalFileList[0].applyNo = item.applyNo
            }
            that.LegalFileList[0].tmLawFileId = item.tmLawFileId
            if (commonFun.isNotEmpty(item.tmLawFileId)) {
              that.getLegalFileByIndexAndLawFileId(id, 0, item.tmLawFileId)
            } else {
              that.getLegalFileByIndex(id, 0);
            }
          }
          if (item.formType == '1') {
            that.LegalFileList[1].status = item.status
            if (item.applyNo) {
              that.LegalFileList[1].applyNo = item.applyNo
            }
            that.LegalFileList[1].tmLawFileId = item.tmLawFileId
            if (commonFun.isNotEmpty(item.tmLawFileId)) {
              that.getLegalFileByIndexAndLawFileId(id, 1, item.tmLawFileId)
            } else {
              that.getLegalFileByIndex(id, 1);
            }
          }
          if (item.formType == '2') {
            that.LegalFileList[2].status = item.status
            if (item.applyNo) {
              that.LegalFileList[2].applyNo = item.applyNo
            }
            that.LegalFileList[2].tmLawFileId = item.tmLawFileId
            if (commonFun.isNotEmpty(item.tmLawFileId)) {
              that.getLegalFileByIndexAndLawFileId(id, 2, item.tmLawFileId)
            } else {
              that.getLegalFileByIndex(id, 2);
            }
          }
          if (item.formType == '4') {
            that.LegalFileList[4].status = item.status
            if (item.applyNo) {
              that.LegalFileList[4].applyNo = item.applyNo
            }
            that.LegalFileList[4].tmLawFileId = item.tmLawFileId
            if (commonFun.isNotEmpty(item.tmLawFileId)) {
              that.getLegalFileByIndexAndLawFileId(id, 4, item.tmLawFileId)
            } else {
              that.getLegalFileByIndex(id, 4);
            }
          }
        })

      });
    },
    saveDetail() {
      let that = this;
      //校验 中文英文邀请码 必填 为了创建法务的时候 带值
      const p1 = new Promise((resolve, reject) => {
        this.$refs["unitOfAccountForm"].validateField('groupSupplierCode', errMsg => {
          if (!errMsg) resolve()
        });
      })

      const p2 = new Promise((resolve, reject) => {
        this.$refs["unitOfAccountForm"].validateField('nameCn', errMsg => {
          if (!errMsg) resolve()
        })
      })
      const p3 = new Promise((resolve, reject) => {
        this.$refs["unitOfAccountForm"].validateField('nameEn', errMsg => {
          if (!errMsg) resolve()
        })
      })
      Promise.all([p1, p2, p3]).then(() => {
        let data = {
          unitOfAccount: this.unitOfAccountForm,
          linkUsers: this.formlinkUsers.linkUsersList,
          unitOfAccountAddressList: that.formAddress.plantList
        }
        console.log(data)
        unitApi.save(data).then(res => {
          console.log(res)
          if (res.code == 200) {
            that.$message({
              message: that.$t("common.saveSuccess"),
              type: "success"
            });
            that.id = res.data
            that.getDetail(res.data)
            that.getAccountUnitAddress(res.data)
            that.getLawFile(res.data)
            that.$router.replace({
              path: `/SupplierDataMaintenance`,
              query: {
                id: res.data,
                timestamp: new Date().getTime()
              }
            })
          }
        });
      })
    },
    submitDetail() {
      let that = this
      const p1 = new Promise((resolve, reject) => {
        this.$refs["unitOfAccountForm"].validate(valid => {
          if (valid) resolve()
          return false;
        })
      })
      if (this.formlinkUsers.linkUsersList.length == 0) {
        that.$message({ message: that.$t("settlementUnit.leastContact"), type: "warning" });
        return
      }
      if (this.formAddress.plantList.length == 0) {
        that.$message({ message: that.$t("settlementUnit.leastAddress"), type: "warning" });
        return
      }
      if (this.formAddress.plantList.length < 2 && that.unitOfAccountForm.groupType != 'CARRIER') {
        that.$message({ message: '至少两行地址明细', type: "warning" });
        return
      }
      const p2 = new Promise((resolve, reject) => {
        this.$refs["formlinkUsers"].validate(valid => {
          if (valid) resolve()
        })
      })
      const p3 = new Promise((resolve, reject) => {
        this.$refs["formAddress"].validate(valid => {
          if (valid) resolve()
        })
      })
      let list = this.formAddress.plantList
      for (let i = 0, len = list.length; i < len; i++) {
        if (commonFun.isEmpty(list[i].areaId)) {
          that.$message({ message: that.$t("supplierManage.selectArea"), type: "warning" });
          return false;
        }
        if (commonFun.isEmpty(list[i].users.length < 1)) {
          that.$message({ message: "请填写联系人", type: "warning" });
          return false;
        }
        if (list[i].existsFile && list[i].existsFile == 'N') {
          that.$message({ message: "请上传地址信息栏的资质文件", type: "warning" });
          return false;
        }
      }


      Promise.all([p1, p2, p3]).then(() => {
        Promise.all([
          that.getLegalFileResult2(that.id, 0, that.LegalFileList[0].tmLawFileId),
          that.getLegalFileResult2(that.id, 1, that.LegalFileList[0].tmLawFileId),
          that.getLegalFileResult2(that.id, 2, that.LegalFileList[0].tmLawFileId),
          that.getLegalFileResult2(that.id, 4, that.LegalFileList[0].tmLawFileId),

          // that.getLegalFileResult(that.id,4),
          that.getLegalFileResult(that.id, 5),
          that.getLegalFileResult(that.id, 6),
          that.getLegalFileResult(that.id, 7),
          that.getLegalFileResult(that.id, 8),
          that.getLegalFileResult(that.id, 9),
          that.getLegalFileResult(that.id, 10),
          that.getLegalFileResult(that.id, 11),
          that.getLegalFileResult(that.id, 12),
          that.getLegalFileResult(that.id, 13),
          that.getLegalFileResult(that.id, 14),
          // that.getLegalFileResult(that.id,15),
          // that.getLegalFileResult(that.id,16),
        ]).then(res => {
          if (this.emplFlag == 'SUP') {//供应商不校验： 礼品和招待 国家公信网截屏 第三方新增及修改申请表
            res.pop()
            res.pop()
            res.pop()
          }
          //判断false出现过几次
          var frequency = {};
          for (let i = 0; i < res.length; i++) {
            var item = res[i]
            if (frequency[item]) {
              frequency[item]++;
            } else {
              frequency[item] = 1;
            }
          }
          console.log(frequency)

          if (res.indexOf(false) < 0) {//全部上传
            let data = {
              unitOfAccount: this.unitOfAccountForm,
              linkUsers: this.formlinkUsers.linkUsersList,
              unitOfAccountAddressList: that.formAddress.plantList
            }
            console.log(data)
            unitApi.submit(data).then(res => {
              console.log(res)
              if (res.code == 200) {
                that.$message({
                  message: this.$t("common.submitSuccess"),
                  type: "success"
                });
                that.historyBack()
              }
            });
          } else {
            if (frequency.false <= 1) {//如果只有一个没上传
              if (!res[1] || !res[2]) {// 下标 1，2有一个true就可以
                let data = {
                  unitOfAccount: this.unitOfAccountForm,
                  linkUsers: this.formlinkUsers.linkUsersList,
                  unitOfAccountAddressList: that.formAddress.plantList
                }
                console.log(data)
                unitApi.submit(data).then(res => {
                  console.log(res)
                  if (res.code == 200) {
                    that.$message({
                      message: this.$t("common.submitSuccess"),
                      type: "success"
                    });
                    that.historyBack()
                  }
                });
              } else {
                that.$message({
                  message: '资质文件全都必填',
                  type: "warning"
                });
              }
            } else {
              that.$message({
                message: '资质文件全都必填',
                type: "warning"
              });
            }

          }
        })
      })
    },
    //根据邀请码获取供应商
    blurGroupSupplierCode() {
      let that = this
      let loginSupplierId = that.loginSupplierId;
      let code = that.unitOfAccountForm.groupSupplierCode
      that.unitOfAccountForm.ssCategoryLeaderId = ''
      if (!loginSupplierId && !code) {
        that.unitOfAccountForm.groupType = ''
        that.unitOfAccountForm.nameShort = ''
        that.unitOfAccountForm.nameCn = ''
        that.unitOfAccountForm.nameEn = ''
        that.unitOfAccountForm.department = ''
        that.unitOfAccountForm.ssCategoryLeaderId = ''
        return
      }
      if (commonFun.isNotEmpty(this.$route.query.id)) {
        return
      }
      supplierApi.getResourceList({ tmSupplierId: loginSupplierId, invitationCode: code }).then((res) => {
        if (res.resultData.length == 1) {
          if (res.resultData[0].status == '0') {
            that.$message({ message: "供应商已被禁用", type: "warning" });
            return
          }

          that.unitOfAccountForm.groupType = res.resultData[0].groupType
          that.unitOfAccountForm.nameShort = res.resultData[0].supplierNameShort
          that.unitOfAccountForm.nameCn = res.resultData[0].supplierName
          that.groupName = res.resultData[0].supplierName
          that.unitOfAccountForm.nameEn = res.resultData[0].supplierNameEn
          that.unitOfAccountForm.department = res.resultData[0].department
          that.unitOfAccountForm.tmSupplierId = res.resultData[0].tmSupplierId
          that.unitOfAccountForm.groupSupplierCode = res.resultData[0].invitationCode
          // supplierApi.potentialSupplierDetail(res.resultData[0].tmSupplierId).then(supplierRes => { });
          // if (res.resultData[0].department == 'NFC') {
          //   this.getSubmitBySS("NFC")
          // } else if (res.resultData[0].department == 'SS') {
          //   this.getSubmitBySS("SS")
          // } else if (res.resultData[0].department == 'MDM') {
          //   this.getSubmitBySS("MDM")
          // }
        } else {
          that.unitOfAccountForm.groupType = ''
          that.unitOfAccountForm.nameShort = ''
          that.unitOfAccountForm.nameCn = ''
          that.unitOfAccountForm.nameEn = ''
          that.unitOfAccountForm.department = ''
          that.unitOfAccountForm.groupSupplierCode = ''
          that.unitOfAccountForm.ssCategoryLeaderId = ''
          that.$message({ message: "未找到对应的供应商邀请码/编码", type: "warning" });
        }
      });
    },
    clearGroupSupplierCode() {
      let that = this
      that.unitOfAccountForm.groupType = ''
      that.unitOfAccountForm.nameShort = ''
      that.unitOfAccountForm.nameCn = ''
      that.unitOfAccountForm.nameEn = ''
      that.unitOfAccountForm.department = ''
      that.unitOfAccountForm.ssCategoryLeaderId = ''
    },
    addUser() {
      let len = this.formlinkUsers.linkUsersList.length;
      var list = {
        delIds: len
      };
      if (this.formlinkUsers.linkUsersList == null) {
        this.formlinkUsers.linkUsersList = [];
        this.formlinkUsers.linkUsersList.push(list);
      } else {
        this.formlinkUsers.linkUsersList.push(list);
      }
    },
    delUser() {
      let that = this
      let list = this.formlinkUsers.linkUsersList;
      console.log("GY🚀 ~ file: SupplierDataEdit.vue:1250 ~ delUser ~ list:", list);

      let rows = this.$refs.linkUsersList.selection;
      console.log("GY🚀 ~ file: SupplierDataEdit.vue:1253 ~ delUser ~ rows:", rows);
      if (rows.length == 0) {
        that.$message({ message: that.$t("common.pleaseSelectData"), type: "warning" });
        return
      } else {
        rows.forEach(function (item, index) {
          list.forEach(function (itemI, indexI) {
            // 如果选中数据跟元数据某一条标识相等，删除对应的源数据
            if (item.delIds === itemI.delIds) {
              list.splice(indexI, 1);
            }
          });
        });
      }
      //删除后重新循环list
      list.forEach(function (item, index) {
        item.delIds = index
      });
      this.formlinkUsers.linkUsersList = list;

    },
    //根据邀请码获取供应商
    addSupplierAddress() {
      //先根据邀请码获取供应商
      let that = this
      let code = that.unitOfAccountForm.groupSupplierCode
      // if (!code) {
      //   that.$message({
      //     message: '先填写邀请码',
      //     type: "warning"
      //   });
      //   return;
      // }
      supplierApi.getResourceList({ invitationCode: code }).then((res) => {
        if (res.resultData.length > 0) {
          that.unitOfAccountForm.tmSupplierId = res.resultData[0].tmSupplierId
          that.tmSupplierId = res.resultData[0].tmSupplierId
          // that.getAddressById(res.resultData[0].tmSupplierId)
          that.showSelDcMultipleDialog = true;
          that.$nextTick(() => {
            that.DestroyIncomeStatistics = true;
          });
        } else {
          that.$message({
            message: '无数据',
            type: "warning"
          });
        }
      });
    },
    editPlant() {
      if (this.$refs.plantList.selection.length > 1) {
        this.$message.error('请仅勾选一条工厂数据进行修改！')
      } else {
        this.dialogVisible2 = true
        this.plantCodeForm = {
          plantCode: ""
        }
      }
    },
    savePlantCode() {
      let params = {
        tmSupplierId: this.$refs.plantList.selection[0].tmSupplierId,
        plantCode: this.plantCodeForm.plantCode,
      }
      unitApi.editPlantCode(params).then((res) => {
        if (res.code == 200) {
          this.dialogVisible2 = false
          this.getAccountUnitAddress(this.$route.query.id)
        }
        console.log("🚀 ~ unitApi.editPlantCode ~ res:", res)
      })
    },
    cancelPlantCode() {
      this.dialogVisible2 = false
      this.plantCodeForm = {
        plantCode: ""
      }
    },
    //地址选择
    selectDcMethod: function (dcList) {
      console.log(dcList)
      let _this = this;
      this.DestroyIncomeStatistics = false;
      if (dcList.length == 0) {
        this.showSelDcMultipleDialog = false;
        return;
      }
      let platList = this.formAddress.plantList
      platList.forEach(function (item, index) {
        dcList.forEach(function (itemI, indexI) {
          // 如果选中数据跟 已经选的相等，删除对应的源数据
          if (item.tmSupplierId === itemI.tmSupplierId) {
            dcList.splice(indexI, 1);
          }
        });
      });
      if (dcList.length > 0) {
        let _arr = []
        dcList.map((item, index) => {
          _arr.push(Object.assign({}, item, { plantType: 'PLANT', status: '1', existsFile: 'Y' }))
        })
        _this.formAddress.plantList.push.apply(_this.formAddress.plantList, _arr)
      }
      // let temp = dcList.map(function(item,index) {
      //     let obj = {
      //         tmSupplierId: item["tmSupplierId"],
      //         nameCn: item["nameCn"],
      //         nameEn: item["nameEn"],
      //         plantType:'PLANT',
      //         status:'1'
      //     }
      //     return obj;
      // });
      // if(temp.length>0){
      //     _this.formAddress.plantList.push.apply(_this.formAddress.plantList, temp)
      // }
      _this.formAddress.plantList.forEach(function (item, index) {
        if (index == 0) {
          item.plantType = 'REG'
        }
      });
      this.showSelDcMultipleDialog = false;
    },
    closeSelDcMultipleDialog() {
      this.DestroyIncomeStatistics = false;
    },
    //保存区域
    saveArea() {
      let that = this
      this.formAddress.plantList[that.rowIndex].countryId = that.AreaForm.country
      that.$set(that.formAddress.plantList[that.rowIndex], `countryName`, that.countryName)
      this.formAddress.plantList[that.rowIndex].provinceId = that.AreaForm.province
      that.$set(that.formAddress.plantList[that.rowIndex], `provinceName`, that.provinceName)
      this.formAddress.plantList[that.rowIndex].cityId = that.AreaForm.city
      that.$set(that.formAddress.plantList[that.rowIndex], `cityName`, that.cityName)
      this.formAddress.plantList[that.rowIndex].areaId = that.AreaForm.tmAreaId
      that.$set(that.formAddress.plantList[that.rowIndex], `areaName`, that.areaName)
      this.AreaDialog = false
      console.log(this.formAddress.plantList)
    },
    selectArea(row, index) {
      let that = this
      if (index != 0 && that.unitOfAccountForm.groupType == 'SUPPLIER') {//不是第一行 且  是物料 则不可编辑
        return;
      }
      if (index != 0) {//不是第一行则不可编辑
        this.disableAreaInput = true
      } else {
        this.disableAreaInput = false
      }
      //取出省市区 带到弹框中
      this.AreaDialog = true
      this.rowIndex = index

      if (commonFun.isNotEmpty(row.countryId)) {
        that.countryChange(row.countryId)
        that.provinceChange(row.provinceId)
        that.cityChange(row.cityId)
      }
      Promise.all([that.countryChange(), that.provinceChange(), that.cityChange()]).then(() => {
        if (commonFun.isNotEmpty(row.countryId)) {
          that.AreaForm.country = row.countryId
          that.AreaForm.province = row.provinceId
          that.AreaForm.city = row.cityId
          that.AreaForm.tmAreaId = row.areaId
        }
      })
    },
    //获取国家
    getArea() {
      let that = this
      let data = {
        areaLevel: '0',
      }
      supplierApi.getArea(data).then(res => {
        this.countryList = res.data
      });
    },
    //国家选择之后 获取省份
    countryChange(val) {
      return new Promise((resolve, reject) => {
        let that = this
        let selectedWorkName = {};
        selectedWorkName = this.countryList.find((item) => {
          return item.tmAreaId === val;
          //筛选出匹配数据，是对应数据的整个对象
        });
        if (selectedWorkName) {
          that.countryName = selectedWorkName.name
        }
        that.AreaForm.province = ''
        that.AreaForm.city = ''
        that.AreaForm.tmAreaId = ''
        let data = {
          areaLevel: '1',
          parentId: val
        }
        supplierApi.getArea(data).then(res => {
          this.provinceList = res.data
          resolve()
        });
      })
    },
    //省份选择之后 获取市
    provinceChange(val) {
      return new Promise((resolve, reject) => {
        let that = this
        let selectedWorkName = {};
        selectedWorkName = this.provinceList.find((item) => {
          return item.tmAreaId === val;
          //筛选出匹配数据，是对应数据的整个对象
        });
        if (selectedWorkName) {
          that.provinceName = selectedWorkName.name
        }
        that.AreaForm.city = ''
        that.AreaForm.tmAreaId = ''
        let data = {
          areaLevel: '2',
          parentId: val
        }
        supplierApi.getArea(data).then(res => {
          this.cityList = res.data
          resolve()
        });
      })

    },
    //城市选择之后 获取区域
    cityChange(val) {
      return new Promise((resolve, reject) => {
        let that = this
        let selectedWorkName = {};
        selectedWorkName = this.cityList.find((item) => {
          return item.tmAreaId === val;
          //筛选出匹配数据，是对应数据的整个对象
        });
        if (selectedWorkName) {
          that.cityName = selectedWorkName.name
        }
        that.AreaForm.tmAreaId = ''
        let data = {
          areaLevel: '3',
          parentId: val
        }
        supplierApi.getArea(data).then(res => {
          this.AreaList = res.data
          resolve()
        });
      })

    },
    //国家省市区全部选完
    AreaChange(val) {
      let that = this
      let selectedWorkName = {};
      selectedWorkName = this.AreaList.find((item) => {
        return item.tmAreaId === val;
        //筛选出匹配数据，是对应数据的整个对象
      });
      if (selectedWorkName) {
        that.areaName = selectedWorkName.name
      }
    },
    //查看资质文件
    seeQualificationFile(row, index) {
      let that = this
      let code = that.unitOfAccountForm.groupSupplierCode
      // if (!code) {
      //   that.$message({
      //     message: '先填写邀请码',
      //     type: "warning"
      //   });
      //   return;
      // }
      if (index != 0 && that.unitOfAccountForm.groupType == 'SUPPLIER') {//不是第一行 且 groupType=SUPPLIER 则不可编辑
        this.disableAddressUserInput = true
      } else {
        this.disableAddressUserInput = false
      }
      this.rowIndex = index
      this.QualificationFileId = row.tmSupplierId
      this.qualificationsDialog = true
      let groupType = this.unitOfAccountForm.groupType
      if (groupType == 'SUPPLIER') {
        that.qualificationsList = [
          { HeaderName: '营业执照(三合一)' },
          { HeaderName: '生产许可证' },
          { HeaderName: '经营许可证' }
        ]
      } else if (groupType == 'DC') {
        that.qualificationsList = [
          { HeaderName: '营业执照(三合一)' },
          { HeaderName: '房产证或相关房屋合法证明' },
          { HeaderName: '道路运输经营许可证' },
        ]
      } else if (groupType == 'CARRIER') {
        that.qualificationsList = [
          { HeaderName: '营业执照(三合一)' },
          { HeaderName: '道路运输经营许可证' },
        ]
      }
      if (row.tmSupplierId) {//如果有id，获取一下 三种资质文件
        this.getBusinessLicense()
        this.getProductionLicense()
        this.getManagementLicense()
      } else {
        if (that.formAddress.plantList[index].businessCertificateDocument) {
          let obj = Object.assign({}, that.qualificationsList[0], that.formAddress.plantList[index].businessCertificateDocument)
          that.qualificationsList.splice(0, 1, obj);
        }
        if (that.formAddress.plantList[index].productionLicenseDocument) {
          let obj = Object.assign({}, that.qualificationsList[1], that.formAddress.plantList[index].productionLicenseDocument)
          that.qualificationsList.splice(1, 1, obj);
        }
        if (that.formAddress.plantList[index].businessLicenseDocument) {
          let obj = Object.assign({}, that.qualificationsList[2], that.formAddress.plantList[index].businessLicenseDocument)
          that.qualificationsList.splice(2, 1, obj);
        }
      }
    },
    //获取资质文件 营业执照
    getBusinessLicense: function () {
      let that = this
      let attachment = {};
      attachment.seq = 'BUSINESS_CERTIFICA';
      attachment.tsRecId = this.QualificationFileId;
      attachment.tsReckindId = 'SUPPLIER';
      fileService.getFileList(attachment).then((fileRes) => {
        if (fileRes.length > 0) {
          // 通过splice()方法，删除某个元素后，再添加一个元素，达到“赋值”的效果 否则页面不会从新渲染
          let obj = Object.assign({}, that.qualificationsList[0], fileRes[0])
          that.qualificationsList.splice(0, 1, obj);
        }
      })
    },
    //获取资质文件 生产许可证
    getProductionLicense: function () {
      let that = this
      let attachment = {};
      attachment.seq = 'PRODUCTION_LICENSE';
      attachment.tsRecId = this.QualificationFileId;
      attachment.tsReckindId = 'SUPPLIER';
      fileService.getFileList(attachment).then((fileRes) => {
        if (fileRes.length > 0) {
          let obj = Object.assign({}, that.qualificationsList[1], fileRes[0])
          that.qualificationsList.splice(1, 1, obj);
        }

      })
    },
    //获取资质文件 经营许可证
    getManagementLicense: function () {
      let that = this
      let attachment = {};
      attachment.seq = 'BUSINESS_LICENSE';
      attachment.tsRecId = this.QualificationFileId;
      attachment.tsReckindId = 'SUPPLIER';
      fileService.getFileList(attachment).then((fileRes) => {
        if (fileRes.length > 0) {
          let obj = Object.assign({}, that.qualificationsList[2], fileRes[0])
          that.qualificationsList.splice(2, 1, obj);
        }

      })
    },
    beforeQualifications() {
    },
    getFileIndex(index) {
      let that = this
      switch (index) {
        case 0:
          that.seq = 'BUSINESS_CERTIFICA'
          break;
        case 1:
          that.seq = 'PRODUCTION_LICENSE'
          break;
        case 2:
          that.seq = 'BUSINESS_LICENSE'
          break;
      }
    },
    //上传弹框中的资质文件
    uploadQualifications(item) {
      let that = this;
      let QualificationFileId = this.QualificationFileId
      let seq = that.seq
      if (QualificationFileId) {//先判断有没有id
        let formData = new FormData();
        formData.append("file", item.file);
        fileService.fileUpload(formData).then((res) => {
          //调用后台方法进行文件关系维护
          let attachment = {};
          attachment.documents = res.data;
          attachment.seq = seq;
          attachment.tsRecId = QualificationFileId;
          attachment.tsReckindId = 'SUPPLIER';
          fileService.saveFile(attachment).then((saveRes) => {
            fileService.getFileList(attachment).then(fileRes => {
              //上传成功后 删除上次上传的
              if (fileRes.length > 1) {
                let tmDocumentId = fileRes[0].tmDocumentId
                fileService.deleteFile(tmDocumentId).then(Delres => {
                  switch (seq) {
                    case 'BUSINESS_CERTIFICA':
                      that.getBusinessLicense()
                      break;
                    case 'PRODUCTION_LICENSE':
                      that.getProductionLicense()
                      break;
                    case 'BUSINESS_LICENSE':
                      that.getManagementLicense()
                      break;
                  }
                });
              } else {
                switch (seq) {
                  case 'BUSINESS_CERTIFICA':
                    that.getBusinessLicense()
                    break;
                  case 'PRODUCTION_LICENSE':
                    that.getProductionLicense()
                    break;
                  case 'BUSINESS_LICENSE':
                    that.getManagementLicense()
                    break;
                }
              }
            });
            that.$set(that.formAddress.plantList[that.rowIndex], `existsFile`, 'Y')
          })
        }).catch((error) => {
          //文件上传失败
          Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
        });
      } else {
        let formData = new FormData();
        formData.append("file", item.file);
        fileService.fileUpload(formData).then((res) => {//没有id无法保存关系
          let documents = res.data[0]
          let obj = {}
          switch (seq) {
            case 'BUSINESS_CERTIFICA':
              obj = Object.assign({}, that.qualificationsList[0], documents)
              that.qualificationsList.splice(0, 1, obj);
              that.formAddress.plantList[that.rowIndex].businessCertificateDocument = documents
              break;
            case 'PRODUCTION_LICENSE':
              obj = Object.assign({}, that.qualificationsList[1], documents)
              that.qualificationsList.splice(1, 1, obj);
              that.formAddress.plantList[that.rowIndex].productionLicenseDocument = documents
              break;
            case 'BUSINESS_LICENSE':
              obj = Object.assign({}, that.qualificationsList[2], documents)
              that.qualificationsList.splice(2, 1, obj);
              that.formAddress.plantList[that.rowIndex].businessLicenseDocument = documents
              break;
          }
          that.$set(that.formAddress.plantList[that.rowIndex], `existsFile`, 'Y')
        }).catch((error) => {
          //文件上传失败
          Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
        });
      }
    },
    //下载资质文件
    downloadQualifications(row) {
      fileService.downloadFile(row).then((res) => { })
    },
    //删除弹框中的资质文件
    delQualificationsr(index, row) {
      let that = this
      console.log(row)
      if (commonFun.isNotEmpty(row.tmDocumentId)) {
        fileService.deleteFile(row.tmDocumentId).then((res) => {
          //删除成功删除列表数据
          that.$message({
            message: this.$t("common.success"),
            type: "success"
          });
          let obj = {}
          switch (index) {
            case 0:
              that.qualificationsList.splice(0, 1, { HeaderName: '营业执照(三合一)' });
              break;
            case 1:
              that.qualificationsList.splice(1, 1, { HeaderName: '生产许可证' });
              break;
            case 2:
              that.qualificationsList.splice(2, 1, { HeaderName: '经营许可证' });
              break;
          }
        })
      } else {//没有当前行id
        let obj = {}
        switch (index) {
          case 0:
            if (that.formAddress.plantList[0].businessCertificateDocument) {
              that.qualificationsList.splice(0, 1, { HeaderName: '营业执照' });
              delete that.formAddress.plantList[0]["businessCertificateDocument"]
            }
            break;
          case 1:
            if (that.formAddress.plantList[0].productionLicenseDocument) {
              that.qualificationsList.splice(1, 1, { HeaderName: '生产许可证' });
              delete that.formAddress.plantList[0]["productionLicenseDocument"]
            }
            break;
          case 2:
            if (that.formAddress.plantList[0].businessLicenseDocument) {
              that.qualificationsList.splice(2, 1, { HeaderName: '经营许可证' });
              delete that.formAddress.plantList[0]["businessLicenseDocument"]
            }
            break;
        }
      }
    },
    //关闭地址中的上传资质文件
    closeQualificationsDialog() {
      let that = this
      this.qualificationsDialog = false
      let groupType = this.unitOfAccountForm.groupType
      if (groupType == 'SUPPLIER') {
        that.qualificationsList = [
          { HeaderName: '营业执照(三合一)' },
          { HeaderName: '生产许可证' },
          { HeaderName: '经营许可证' }
        ]
      } else if (groupType == 'DC') {
        that.qualificationsList = [
          { HeaderName: '营业执照(三合一)' },
          { HeaderName: '房产证或相关房屋合法证明' },
          { HeaderName: '道路运输经营许可证' },
        ]
      } else if (groupType == 'CARRIER') {
        that.qualificationsList = [
          { HeaderName: '营业执照(三合一)' },
          { HeaderName: '道路运输经营许可证' },
        ]
      }
    },
    getAddressById(id) {
      let that = this
      let data = {
        pageNum: 1,
        pageSize: 15,
        tmSupplierId: id
      }
      unitApi.getAddress(data, id).then(res => {
        console.log(res)

      });
    },
    delSupplierAddress() {
      let that = this
      let list = this.formAddress.plantList;
      let rows = this.$refs.plantList.selection;
      console.log(rows)
      if (rows.length == 0) {
        that.$message({ message: that.$t("common.pleaseSelectData"), type: "warning" });
        return
      } else {
        rows.forEach(function (item, index) {
          list.forEach(function (itemI, indexI) {
            if (item.tmSupplierId === itemI.tmSupplierId) {
              list.splice(indexI, 1);
            }
          });
        });
      }
      //删除后重新循环list
      list.forEach(function (item, index) {
        item.delIds = index
      });
      that.formAddress.plantList = list;
    },
    getSubmitBySS(type) {
      let data = {
        typeList: ['SS', 'ADMIN', "NFC"]
      }
      // if (type == 'MDM') {
      //   data = {
      //     typeList: ['SS', 'ADMIN', "NFC"]
      //   }
      // } else {
      //   data = {
      //     type: type
      //   }
      // }
      BCApi.getCategoryLeader(data).then(res => {
        if (res.code == '200') {
          // this.SubmitBySSList = res.data
          var hash = {}
          this.SubmitBySSList = res.data.reduce(function (item, next) {
            hash[next.userName] ? '' : hash[next.userName] = true && item.push(next)
            return item
          }, [])
        }
      });
    },
    //审批
    approvalFun() {
      this.approvalVisible = true
    },
    //审批
    approvalConfirm() {
      let that = this;
      this.$refs.approvaForm.validate(valid => {
        if (valid) {
          //不通过时，不用校验 资质文件
          if (that.approvaForm.approvalResults == 'REJECT') {
            that.approvalConfirmAxios()
          } else {

            if ((!this.$route.query.id || this.canAudit || ((this.auditStatus == 'draft' || this.auditStatus == 'appr_rej') && this.unitOfAccountForm.createType == 'MDM')) && this.emplFlag == 'MDM') {
              if (!this.unitOfAccountForm.code) {
                this.$message.error("请输入结算单位编码")
                return
              }
            }
            //如果是mdm审批，校验后两个资质文件：国家公信网截屏，和 数据电文有效性补充协议
            // /数据电文有效性补充协议删了 不用校验了
            if (that.emplFlag == 'MDM') {
              Promise.all([
                that.getLegalFileResult(that.id, 13),
                // that.getLegalFileResult(that.id,14),
                // that.getLegalFileResult(that.id,15),
                // that.getLegalFileResult(that.id,16),
              ]).then(res => {
                if (res.indexOf(false) < 0) {//全部上传
                  that.approvalConfirmAxios()
                } else {
                  that.$message({
                    message: '资质文件全都必填',
                    type: "warning"
                  });
                  this.approvalVisible = false
                }
              })
            } else {
              that.approvalConfirmAxios()
            }
          }
        } else {
          return false;
        }
      });
      this.approvalVisible = true
    },
    approvalConfirmAxios() {
      let that = this
      let data = {
        status: that.approvaForm.approvalResults,
        remark: that.approvaForm.approvalRemarks,
        bizId: that.id,
        supplierCode: that.unitOfAccountForm.code
      }
      unitApi.approval(data).then(res => {
        if (res.code == '200') {
          that.$message({
            message: this.$t("common.success"),
            type: "success"
          });
          this.historyBack()
        }
      });
    },
    //发送MDM
    sendToMDM() {
      unitApi.sendToMDM(this.unitOfAccountForm.tmUnitOfAccountId).then(res => {
        if (res.code == '200') {
          this.$message({
            message: this.$t("common.success"),
            type: "success"
          });
          this.historyBack()
        }
      });

    },
    //获取tab页法务文件index
    getLegalFileIndex(index, row) {
      this.rowIndexLegalFile = index
      this.tsReckindId = 'LegalFile' + index
      this.rowStatus = row.status
      this.tmLawFileId = row.tmLawFileId
    },
    //上传tab页中法务文件
    uploadLegalFile(item) {
      let that = this;
      let index = this.rowIndexLegalFile
      let tsReckindId = that.tsReckindId
      let rowStatus = this.rowStatus
      let tmLawFileId = this.tmLawFileId
      console.log(tmLawFileId)
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        //调用后台方法进行文件关系维护
        let attachment = {};
        attachment.documents = res.data;
        attachment.seq = 1;
        attachment.tsRecId = that.id;
        attachment.tsReckindId = that.tsReckindId;
        fileService.saveFile(attachment).then((saveRes) => {
          //获取列表
          if (tmLawFileId) {
            that.getLegalFileByIndexAndLawFileId(that.id, index, tmLawFileId)
          } else {
            that.getLegalFileOther(that.id, index)
          }
        })
        // if(index<4){//前四行
        if (index < 5) {//前5行，因为加了一行空白的
          if ((rowStatus == 'appr_pass' || rowStatus == 'pigeonhole') && tmLawFileId) {
            //调归档接口
            unitApi.pigeonhole(tmLawFileId).then(res => {
              if (res.code == '200') { }
            });
          }
        }
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    //初始化页面 获取法务文件tab页面列表
    getLegalFileOther(id, index) {
      if (index) {//有index 是上传之后调用的
        this.getLegalFileByIndex(id, index);
      } else {//没有index初始化页面调用
        this.getLegalFileByIndex(id, 0);
        this.getLegalFileByIndex(id, 1);
        this.getLegalFileByIndex(id, 2);
        // this.getLegalFileByIndex(id,3);
        this.getLegalFileByIndex(id, 4);
        this.getLegalFileByIndex(id, 5);
        this.getLegalFileByIndex(id, 6);
        this.getLegalFileByIndex(id, 7);
        this.getLegalFileByIndex(id, 8);
        this.getLegalFileByIndex(id, 9);
        this.getLegalFileByIndex(id, 10);
        this.getLegalFileByIndex(id, 11);
        this.getLegalFileByIndex(id, 12);
        this.getLegalFileByIndex(id, 13);
        this.getLegalFileByIndex(id, 14);
        // this.getLegalFileByIndex(id,15);
        // this.getLegalFileByIndex(id,16);
      }
    },
    getLegalFileByIndex(id, index) {
      let that = this
      let attachment = {};
      attachment.seq = "1";
      attachment.tsRecId = id;
      attachment.tsReckindId = 'LegalFile' + index;
      fileService.getFileList(attachment).then(fileRes => {
        if (fileRes.length > 0) {
          let newArr = []
          fileRes.sort((a, b) => a['tmDocumentId'] < b['tmDocumentId'] ? 1 : -1);
          // that.LegalFileList[index].historyFile = fileRes
          //历史文件保留4版，不包含最新版
          if (fileRes.length > 4) {
            that.LegalFileList[index] = Object.assign(that.LegalFileList[index], fileRes[0]);
            newArr = fileRes.slice(1, 5)
            console.log(newArr)
            that.LegalFileList[index].historyFile = newArr
          }
          if (fileRes.length == 1) {
            that.LegalFileList[index] = Object.assign(that.LegalFileList[index], fileRes[0]);
            that.LegalFileList[index].historyFile = []
          }
          if (fileRes.length <= 4 && fileRes.length > 1) {
            that.LegalFileList[index] = Object.assign(that.LegalFileList[index], fileRes[0]);
            newArr = fileRes.slice(1, fileRes.length)
            that.LegalFileList[index].historyFile = newArr
          }
          that.$set(that.LegalFileList[index], `currentName`, fileRes[0].documentName)
        }
      });
    },
    getLegalFileByIndexAndLawFileId(id, index, LawFileId) {//合并法务文件详情页上传的
      let that = this
      let arr = []
      let attachment = {};
      attachment.seq = "1";
      attachment.tsRecId = id;
      attachment.tsReckindId = 'LegalFile' + index;
      fileService.getFileList(attachment).then(fileRes => {
        let attachment2 = {};
        attachment2.seq = "1";
        attachment2.tsRecId = LawFileId;
        attachment2.tsReckindId = 'TM_LAW_FIEL_SIGN';
        fileService.getFileList(attachment2).then(fileRes2 => {
          if (fileRes2.length > 0) {
            fileRes2.forEach((value, index) => {
              value['flag'] = 'other'
            })
            arr.push.apply(arr, fileRes2)
          }
          if (fileRes.length > 0) {
            arr.push.apply(arr, fileRes)
          }
          if (arr.length > 4) {
            arr.sort((a, b) => a['tmDocumentId'] < b['tmDocumentId'] ? 1 : -1);
            let newArr = arr.slice(0, 4)
            that.LegalFileList[index] = Object.assign(that.LegalFileList[index], newArr[0]);
            that.LegalFileList[index].historyFile = newArr
            that.$set(that.LegalFileList[index], `currentName`, newArr[0].documentName)
          }
          else if (arr.length > 0 && arr.length <= 4) {
            arr.sort((a, b) => a['tmDocumentId'] < b['tmDocumentId'] ? 1 : -1);
            that.LegalFileList[index] = Object.assign(that.LegalFileList[index], arr[0]);
            that.LegalFileList[index].historyFile = arr
            that.$set(that.LegalFileList[index], `currentName`, arr[0].documentName)
          }
        });
      });
    },
    //下载当前版本
    downloadLegalFile: function (row) {
      console.log(row)
      if (row.flag && row.flag == 'other') {
        console.log('法务文件下载')
        fileService.downloadFileLms(row)
      } else {

        fileService.downloadFile(row)
      }
    },
    //下载资质文件中的历史版本
    downloadhistoryFile: function (row) {
      if (row.flag && row.flag == 'other') {
        console.log('法务文件下载')
        fileService.downloadFileLms(row)
      } else {
        fileService.downloadFile(row)
      }
    },
    toLegalFileDetail(index) {
      this.$router.push({
        path: `/LegalFileDetail`,
        query: { tmSupplierId: this.id, supplierName: this.unitOfAccountForm.nameCn, formType: index, }
      });
    },
    //模版下载
    downloadTemplate: function (path, name) {
      fileService.downloadTemplate(path, name)
    },
    addAddressUser(row, index) {
      let that = this
      let code = that.unitOfAccountForm.groupSupplierCode
      // if (!code) {
      //   that.$message({
      //     message: '先填写邀请码',
      //     type: "warning"
      //   });
      //   return;
      // }
      if (index != 0 && that.unitOfAccountForm.groupType == 'SUPPLIER') {//不是第一行则 并且 groupType==SUPPLIER不可编辑
        this.disableAddressUserInput = true
      } else {
        this.disableAddressUserInput = false
      }
      this.rowIndex = index
      if (row.users && row.users.length > 0) {
        for (let i = 0, len = row.users.length; i < len; i++) {
          row.users[i].delIds = i;
        }
        this.addressAddSupplierContactListForm.addresslinkUsersList = JSON.parse(JSON.stringify(row.users))
        if (that.unitOfAccountForm.groupType == 'SUPPLIER') {
          if (index == 0) {//第一行是注册地址
            that.$set(that.addressAddSupplierContactListForm.addresslinkUsersList[0], `titleDisabled`, true)
            that.$set(that.addressAddSupplierContactListForm.addresslinkUsersList[1], `titleDisabled`, true)
          } else {
            that.$set(that.addressAddSupplierContactListForm.addresslinkUsersList[0], `titleDisabled`, true)
            that.$set(that.addressAddSupplierContactListForm.addresslinkUsersList[1], `titleDisabled`, true)
            that.$set(that.addressAddSupplierContactListForm.addresslinkUsersList[2], `titleDisabled`, true)
          }
        } else {
          if (index == 0) {//第一行是注册地址
            that.$set(that.addressAddSupplierContactListForm.addresslinkUsersList[0], `titleDisabled`, true)
          }
        }
      } else {
        //先判断groupType
        if (that.unitOfAccountForm.groupType == 'SUPPLIER') {
          if (index == 0) {//第一行是注册地址
            that.addressAddSupplierContactListForm.addresslinkUsersList = [
              { title: '2', titleDisabled: true, delIds: 0, },
              { title: '6', titleDisabled: true, delIds: 1, },
            ]
          }
          else {
            // that.addressAddSupplierContactListForm.addresslinkUsersList = [
            //     {title:'2',titleDisabled:true},
            //     {title:'10',titleDisabled:true},
            //     {title:'3',titleDisabled:true},
            // ]
          }

        } else {//DC和CARRIER
          if (index == 0) {//第一行是注册地址
            that.addressAddSupplierContactListForm.addresslinkUsersList = [
              { title: '3', titleDisabled: true, delIds: 0, },
            ]
          } else {
            that.addressAddSupplierContactListForm.addresslinkUsersList = []
          }
        }
      }
      this.addressAddSupplierContactListDialog = true
    },
    //添加地址中的联系人
    addSupplierContactsAddress() {
      let len = this.addressAddSupplierContactListForm.addresslinkUsersList.length;
      var list = {
        delIds: len
      };
      if (this.addressAddSupplierContactListForm.addresslinkUsersList == null) {
        this.addressAddSupplierContactListForm.addresslinkUsersList = [];
        this.addressAddSupplierContactListForm.addresslinkUsersList.push(list);
      } else {
        this.addressAddSupplierContactListForm.addresslinkUsersList.push(list);
      }
    },
    //删除地址中的联系人
    delSupplierContactsAddress() {
      let that = this
      let list = this.addressAddSupplierContactListForm.addresslinkUsersList;
      let rows = this.$refs.addresslinkUsersList.selection;
      if (rows.length == 0) {
        that.$message({ message: that.$t("common.pleaseSelectData"), type: "warning" });
        return
      } else {
        rows.forEach(function (item, index) {
          list.forEach(function (itemI, indexI) {
            // 如果选中数据跟元数据某一条标识相等，删除对应的源数据
            if (item.delIds === itemI.delIds) {
              list.splice(indexI, 1);
            }
          });
        });
      }
      //删除后重新循环list
      list.forEach(function (item, index) {
        item.delIds = index
      });
      this.addressAddSupplierContactListForm.addresslinkUsersList = list;
    },
    //保存地址中的联系人
    saveSupplierContactsAddress() {
      let that = this
      let list = that.addressAddSupplierContactListForm.addresslinkUsersList
      if (list.length == 0) {
        that.$message({ message: '至少添加一行数据', type: "warning" });
        return
      }
      this.$refs.addressAddSupplierContactListForm.validate(valid => {
        if (valid) {
          that.$set(that.formAddress.plantList[that.rowIndex], `users`, list)
          this.addressAddSupplierContactListDialog = false
        } else {
          return false;
        }
      });
    },
    //关闭
    closeSupplierContactsAddress() {
      let that = this
      this.addressAddSupplierContactListDialog = false
      that.$refs.addressAddSupplierContactListForm.clearValidate();
    },
    historyBack: function () {
      this.$router.go(-1);
    },
    //提交的时候校验 资质文件tab页全部上传
    getLegalFileResult(id, index) {
      return new Promise((resolve, reject) => {
        let that = this
        let attachment = {};
        attachment.seq = "1";
        attachment.tsRecId = id;
        attachment.tsReckindId = 'LegalFile' + index;
        fileService.getFileList(attachment).then(fileRes => {
          if (fileRes.length > 0) {
            resolve(true)
          } else {
            resolve(false)
          }
        });

      });
    },
    //提交的时候校验 资质文件tab页前四项上传
    getLegalFileResult2(id, index, tmLawFileId) {
      return new Promise((resolve, reject) => {
        let that = this
        let attachment = {};
        attachment.seq = "1";
        attachment.tsRecId = id;
        attachment.tsReckindId = 'LegalFile' + index;
        fileService.getFileList(attachment).then(fileRes => {
          if (fileRes.length > 0) {
            resolve(true)
          } else {
            if (tmLawFileId) {
              //获取法务文件那里的
              let attachment2 = {};
              attachment2.seq = "1";
              attachment2.tsRecId = tmLawFileId;
              attachment2.tsReckindId = 'TM_LAW_FIEL_SIGN';
              fileService.getFileList(attachment2).then(fileRes2 => {
                if (fileRes2.length > 0) {
                  resolve(true)
                } else {
                  resolve(false)
                }
              });
            } else {
              resolve(false)
            }
          }
        });

      });
    },
    toEngagementDetail() {
      this.$router.push({
        path: `/EngagementDetail`,
        query: {
          tmSupplierId: this.id, supplierName: this.unitOfAccountForm.nameCn,
          supplierNameEn: this.unitOfAccountForm.nameEn, accountNo: this.unitOfAccountForm.code
        }
      });
    },
    //撤回
    withdrawFun() {
      let that = this
      unitApi.withdraw(that.id).then(res => {
        if (res.code == 200) {
          that.getDetail(that.id)
        }
      });
    },
    formatStatus: function (row, column) {
      return row.status == "draft"
        ? row.applyNo + " 草稿"
        : row.status == "appr_ss"
          ? row.applyNo + " 待审核"
          : row.status == "appr_lp"
            ? row.applyNo + " 待法务审核"
            : row.status == "appr_pass"
              ? row.applyNo + " 审核通过"
              : row.status == "appr_rej"
                ? row.applyNo + " 退回"
                : row.status == "pigeonhole"
                  ? row.applyNo + " 归档"
                  : " ";
    },
  }

}
</script>
<style lang="scss" scoped>
.searchBox_top {
  margin-bottom: 10px;
}

.el-table {
  margin-top: 10px;
}

.el-select {
  width: 100%;
}
</style>
<style lang="scss">
.SupplierDataEdit {
  .searchBox_bottom {
    display: flex;

    .el-upload {
      display: block;
    }
  }

  .iconUploadSuccess {
    font-size: 24px;
    color: #f8ab01;
    position: absolute;
    top: 20px;
    right: 6px;
  }

  .operationBox {
    display: flex;

    .el-button--mini,
    .el-button--mini.is-round {
      padding: 9px 15px;
    }
  }

  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    content: "";
  }

  .plantCodeForm
    .el-form-item.is-required:not(.is-no-asterisk)
    > .el-form-item__label:before {
    content: "*";
  }

  .addressInformationTip {
    font-size: 12px;
    color: #f56c6c;
    margin-left: 5px;
  }
}
</style>

